import { render, staticRenderFns } from "./plugin-group-files.vue?vue&type=template&id=0a2b246e&scoped=true&"
import script from "./plugin-group-files.vue?vue&type=script&lang=js&"
export * from "./plugin-group-files.vue?vue&type=script&lang=js&"
import style0 from "./plugin-group-files.vue?vue&type=style&index=0&id=0a2b246e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b246e",
  null
  
)

export default component.exports